import React from "react";

const DataSourceMngContext = React.createContext({
  server: {
    display_name: "API",
  },
  historyDetailImage: null,
  tab: "",
  alert: {},
  servers: [],
  buildings: [],
  input_types: [],
  folders: [],
  years: [],
  select_year: {},
  bill: {},
  setup_details: [],
  overview_status: [],
  status: [],
  devices: {},
  dialog: {
    add_server: false,
    add_device: false,
    select_directory: false,
    upload_transaction: false,
  },
  paginationModel: { page: 0, pageSize: 10 },
  files: [],
  history: [],
  historyDetail: null,
  serverConfig: null,
  loading: {
    modal: false,
  },
  setTab: (tab) => {},
  Add_Server: (body) => {},
  Remove_Server: () => {},
  Remove_Config: () => {},
  setDataState: () => {},
  setDialog: (key, value) => {},
  setLoading: (key, value) => {},
  SyncDevice: () => {},
  fetchBuilding: () => {},
  fetchInputType: () => {},
  fetchDirectory: (folderId) => {},
  fetchConfigure: (cycle) => {},
  fetchServers: () => {},
  fetchDevice: () => {},
  fetchYears: () => {},
  uploadTransaction: () => {},
  fetchDataBill: () => {},
  fetchDataSource: () => {},
  fetchHistory: (id) => {},
  fetchHistoryDetail: (id) => {},
  assignFirstMonth: (id) => {},
  setPaginationModel: (model) => {},
  fetchServerConfig: (code) => {},
  syncNow: (serverId, folderUrl) => {},
});

export default DataSourceMngContext;
